import React, { Component } from 'react';
import { connect } from 'react-redux';

import ConfirmDialog from '../components/confirmDialog';
import { authLogout } from '../store/auth/authSlice';

class LogoutConfirmDialog extends Component {
  constructor(props) {
    super(props);
    this.onConfirm = this.onConfirm.bind(this);
  }

  onConfirm() {
    this.props.authLogout();
    this.props.onClose();
    window.location.replace('/login');
  }

  render() {
    return (
      <ConfirmDialog
        show={this.props.show}
        onClose={this.props.onClose}
        title="Logout"
        question="Are you sure want to logout?"
        onConfirm={this.onConfirm}
      />
    );
  }
}

const actionCreators = {
  authLogout,
};

export default connect(null, actionCreators)(LogoutConfirmDialog);



// WEBPACK FOOTER //
// ./src/containers/logoutConfirmDialog.js